// validators/end-after-start.validator.ts
import { AbstractControl, ValidationErrors } from "@angular/forms";

export function parseTimeToDate(time: any): { hours: number; minutes: number } {
  // Handle different shapes:
  // If time is a string "HH:mm"
  if (typeof time === "string") {
    const [h, m] = time.split(":").map(Number);
    return { hours: h ?? 0, minutes: m ?? 0 };
  }
  // If time is a Date instance
  if (time instanceof Date) {
    return { hours: time.getHours(), minutes: time.getMinutes() };
  }
  // If time is {hour, minute} object
  if (time && typeof time === "object" && "hour" in time && "minute" in time) {
    return { hours: Number(time.hour) || 0, minutes: Number(time.minute) || 0 };
  }
  return { hours: 0, minutes: 0 };
}

export function endAfterStartValidator(
  group: AbstractControl
): ValidationErrors | null {
  const startDate = group.get("startDate")?.value as Date | null;
  const startTime = group.get("startTime")?.value;
  const endDate = group.get("endDate")?.value as Date | null;
  const endTime = group.get("endTime")?.value;

  // Only validate when all four exist
  if (!startDate || !startTime || !endDate || !endTime) {
    // Clear previous control-level error if any
    group.get("endTime")?.setErrors(null);
    return null;
  }

  const { hours: sh, minutes: sm } = parseTimeToDate(startTime);
  const { hours: eh, minutes: em } = parseTimeToDate(endTime);

  // Build full DateTime objects
  const start = new Date(
    startDate.getFullYear(),
    startDate.getMonth(),
    startDate.getDate(),
    sh,
    sm,
    0,
    0
  );
  const end = new Date(
    endDate.getFullYear(),
    endDate.getMonth(),
    endDate.getDate(),
    eh,
    em,
    0,
    0
  );

  // Strictly after
  if (end <= start) {
    // Set group error
    const errors: ValidationErrors = { endNotAfterStart: true };
    // Also set the error on endTime control for highlighting (optional)
    const endTimeControl = group.get("endTime");
    const existing = endTimeControl?.errors || {};
    endTimeControl?.setErrors({ ...existing, endNotAfterStart: true });
    return errors;
  } else {
    // Clear the specific error when valid
    const endTimeControl = group.get("endTime");
    if (endTimeControl?.errors) {
      const { endNotAfterStart, ...rest } = endTimeControl.errors;
      endTimeControl.setErrors(Object.keys(rest).length ? rest : null);
    }
    return null;
  }
}
